import script from "./MsgBoxWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsgBoxWarning.vue?vue&type=script&setup=true&lang=ts"

import "./MsgBoxWarning.vue?vue&type=style&index=0&id=53658acb&lang=css"

const __exports__ = script;

export default __exports__